export default "__VITE_ASSET__C7lI6ZRd__"